module.exports = __webpack_public_path__ + "95f5eef1f950744ea6af247434db5635.svg";